module.exports = function() {
	return new Worker(__webpack_public_path__ + "20fd8cbc3f9c01dec80d.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./src/commands/load-worker.js
// module id = 874
// module chunks = 0